// eslint-disable-next-line unused-imports/no-unused-vars
export function tagGQLFields(fields) {
    return `
    description
    id
    slug
    title
  `;
}
//# sourceMappingURL=tag.fields.js.map